import { useState } from "react";

export const useDynamicConfirmModal = () => {
  const [dynamicConfirmModal, setDynamicConfirmModal] = useState<{
    open: boolean;
    title: string;
    description: string;
    onConfirm: () => void;
  }>({
    open: false,
    title: "",
    description: "",
    onConfirm: () => {},
  });

  const openDynamicConfirmModal = (
    title: string,
    description: string,
    onConfirm: () => void,
  ) => {
    setDynamicConfirmModal({
      open: true,
      title,
      description,
      onConfirm,
    });
  };

  const closeDynamicConfirmModal = () => {
    setDynamicConfirmModal({ ...dynamicConfirmModal, open: false });
  };

  return {
    dynamicConfirmModal,
    openDynamicConfirmModal,
    closeDynamicConfirmModal,
  };
};
